module.exports = __webpack_public_path__ + "assets/webgl/matcap_title.2a83cf56.jpg";